import React from 'react';
import Svg from '../Svg';

const IconSettings03 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 4C16.1193 4 15 5.11929 15 6.5C15 7.88071 16.1193 9 17.5 9C18.8807 9 20 7.88071 20 6.5C20 5.11929 18.8807 4 17.5 4ZM14.6713 3C15.4442 2.3746 16.4284 2 17.5 2C19.9853 2 22 4.01472 22 6.5C22 8.98528 19.9853 11 17.5 11C16.4284 11 15.4442 10.6254 14.6713 10H5.5C3.567 10 2 8.433 2 6.5C2 4.567 3.567 3 5.5 3H14.6713ZM13.2561 5H5.5C4.67157 5 4 5.67157 4 6.5C4 7.32843 4.67157 8 5.5 8H13.2561C13.0902 7.53083 13 7.02595 13 6.5C13 5.97405 13.0902 5.46917 13.2561 5ZM2 17.5C2 15.0147 4.01472 13 6.5 13C7.57165 13 8.5558 13.3746 9.32867 14H18.5C20.433 14 22 15.567 22 17.5C22 19.433 20.433 21 18.5 21H9.32867C8.5558 21.6254 7.57165 22 6.5 22C4.01472 22 2 19.9853 2 17.5ZM10.7439 19H18.5C19.3284 19 20 18.3284 20 17.5C20 16.6716 19.3284 16 18.5 16H10.7439C10.9098 16.4692 11 16.974 11 17.5C11 18.026 10.9098 18.5308 10.7439 19ZM6.5 15C5.11929 15 4 16.1193 4 17.5C4 18.8807 5.11929 20 6.5 20C7.88071 20 9 18.8807 9 17.5C9 16.1193 7.88071 15 6.5 15Z"
    />
  </Svg>
);

export default IconSettings03;
